var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1FekJJAz6Hu32v{position:relative;line-height:10px;overflow:hidden;white-space:nowrap}._1FekJJAz6Hu32v._3qYxjbDMKZCXJg{font-size:8px}.DCDOAa6FopPs9s:hover{background-color:#c1c7d0}.DCDOAa6FopPs9s.aYXvcYtXemTcSj{position:relative}.DCDOAa6FopPs9s.aYXvcYtXemTcSj:hover:before{opacity:.2}.DCDOAa6FopPs9s.aYXvcYtXemTcSj:before{background-color:#c1c7d0;border-radius:50%;content:\"\";height:100%;left:0;opacity:0;position:absolute;top:0;width:100%}._1PufnC2IQNEddD,._257inVnqyNzWRm{background-size:100%;position:absolute;z-index:3;right:1px}._257inVnqyNzWRm{height:7px;width:11px;top:1px;background-image:url(" + escape(require("resources/images/TrelloGoldBadge.png")) + ")}._1PufnC2IQNEddD{height:9px;width:9px;bottom:0;background-image:url(" + escape(require("resources/images/chevron.png")) + ")}", ""]);

// exports
exports.locals = {
	"memberAvatar": "_1FekJJAz6Hu32v",
	"longInitials": "_3qYxjbDMKZCXJg",
	"hoverable": "DCDOAa6FopPs9s",
	"withImage": "aYXvcYtXemTcSj",
	"gold": "_257inVnqyNzWRm",
	"admin": "_1PufnC2IQNEddD"
};